import React from "react";
import AccountIcon from "@icons/myicons/sidebar/accounts.svg?react";
import AccountIconSelected from "@icons/myicons/sidebar/accounts-selected.svg?react";
import CommunityIcon from "@icons/myicons/sidebar/community.svg?react";
import CommunityIconSelected from "@icons/myicons/sidebar/community-selected.svg?react";
import HomeIcon from "@icons/myicons/sidebar/home.svg?react";
import HomeIconSelected from "@icons/myicons/sidebar/home-selected.svg?react";
import InvestmentsIcon from "@icons/myicons/sidebar/investments.svg?react";
import InvestmentsIconSelected from "@icons/myicons/sidebar/investments-selected.svg?react";
import NewsIcon from "@icons/myicons/sidebar/news.svg?react";
import NewsIconSelected from "@icons/myicons/sidebar/news-selected.svg?react";
import QuestionnaireIcon from "@icons/myicons/sidebar/questionnaire-icon.svg?react";
import QuestionnaireIconSelected from "@icons/myicons/sidebar/questionnaire-icon-selected.svg?react";

export const sidebarIcons = {
  accounts: <AccountIcon />,
  accountsSelected: <AccountIconSelected />,
  community: <CommunityIcon />,
  communitySelected: <CommunityIconSelected />,
  home: <HomeIcon />,
  homeSelected: <HomeIconSelected />,
  investments: <InvestmentsIcon />,
  investmentsSelected: <InvestmentsIconSelected />,
  news: <NewsIcon />,
  newsSelected: <NewsIconSelected />,
  questionnaire: <QuestionnaireIcon />,
  questionnaireSelected: <QuestionnaireIconSelected />,
};
